import React from 'react';
import useDynamicSVGImport from '../../hooks/useDynamicSVGImport';

import StyledCardIcon from './CardIconStyles';

interface CardIconProps {
  tokens?: Array<string>;
  isDetails?: boolean;
}

const CardIcon: React.FC<CardIconProps> = ({ tokens = [], isDetails }) => {
  const icon1 = useDynamicSVGImport(tokens[0]);
  const icon2 = useDynamicSVGImport(tokens[1]);
  const _renderTokenIcon = () => {
    if (tokens.length === 2) {
      return (
        <div className={!isDetails ? 'icon-wrapper' : 'details-icon-wrapper'}>
          <img
            className={`${
              !isDetails ? 'icon-image' : 'details-icon-image'
            } first`}
            src={icon1.SvgIcon}
            alt="icon"
          />
          <img
            className={!isDetails ? 'icon-image' : 'details-icon-image'}
            src={icon2.SvgIcon}
            alt="icon"
          />
        </div>
      );
    }

    if (tokens.length === 1) {
      return (
        <div className={!isDetails ? 'icon-wrapper' : 'details-icon-wrapper'}>
          <img className="single-icon-image" src={icon1.SvgIcon} alt="icon" />
        </div>
      );
    }

    return null;
  };

  return (
    <StyledCardIcon>
      <div className="card-icon no-select">{_renderTokenIcon()}</div>
    </StyledCardIcon>
  );
};

export default CardIcon;
